<template lang="pug">
include /mixins

+b.g-modal(
  v-if="currentModalInfo && currentModalInfo.layout && !isClosed"
  :class="{ 'is-active': needShow }"
)
  +e.overlay(
    v-if="currentModalInfo.show_overlay"
    @click.prevent="closeOverlayHandler"
  )
  +e.main(
    :class='{"is-clear": !currentModalInfo.show_overlay}'
  )
    +e.close(
      @click.prevent="close"
      v-if="currentModalInfo.close_x_enabled"
    )
      +b.mdi.mdi-close
    +e.content(:class="{ 'has-close': currentModalInfo.close_x_enabled }")
      +e.inner.COMPONENT(
        :is='currentModalInfo.layout.url ? "a" : "div"'
        :href='currentModalInfo.layout.url'
        target="_blank"
      )
        +e.P.title(v-if="currentModalInfo.layout.title") {{ currentModalInfo.layout.title }}
        +e.P.text(v-if="currentModalInfo.layout.description") {{ currentModalInfo.layout.description }}
        +e.PICTURE.image-wrapper
          source(
            type="image/webp"
            :srcset="currentModalInfo.layout.image.preview_webp"
          )
          +e.IMG.image(:src="currentModalInfo.layout.image.preview")
        +e.button-wrapper
          +e.button.A(
            v-if="currentModalInfo.layout.primary_button_url"
            :href="currentModalInfo.layout.primary_button_url"
            target="_blank"
            :style="buttonStyles"
          ) {{ currentModalInfo.layout.primary_button_text }}
          +e.button(
            v-else-if="currentModalInfo.layout.primary_button_text"
            @click.prevent="close"
            :style="buttonStyles"
          ) {{ currentModalInfo.layout.primary_button_text }}
          +e.button(
            v-else=""
            @click.prevent="close"
          ) {{ _("Детальніше") }}
</template>

<script>
import {
  modalConfigListResource,
  modalConfigViewResource,
} from '@api/modal-config.service'

const AFTER_SECOND_TYPE = 'after_seconds'
const ON_SCROLL_TYPE = 'on_scroll'

export default {
  data() {
    return {
      items: [],
      isClosed: false,
      needShow: false,
    }
  },

  computed: {
    currentModalInfo() {
      return this.items.length ? this.items[0] : null
    },

    buttonStyles() {
      return {
        background: this.currentModalInfo.layout.primary_button_color,
        color: this.currentModalInfo.layout.primary_button_text_color,
      }
    },
  },

  async mounted() {
    await this.getData()
    await this.setData()

    await this.$nextTick()
  },

  beforeDestroy() {
    this.cleanupScrollListener()
  },

  methods: {
    async getData() {
      const params = { url: window.location.pathname }

      const { data } = await modalConfigListResource.execute(params)

      this.items = data.items
    },

    setData() {
      if (!this.currentModalInfo) {
        return
      }
      if (this.currentModalInfo.trigger_type === AFTER_SECOND_TYPE) {
        this.initTimer()
      } else if (this.currentModalInfo.trigger_type === ON_SCROLL_TYPE) {
        this.initScroll()
      }
    },

    initTimer() {
      setTimeout(() => {
        this.needShow = true

        this.saveViewedModal()
      }, this.currentModalInfo.after_seconds * 1000)
    },

    initScroll() {
      const handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
        const scrolledPercent = (scrollTop / windowHeight) * 100

        if (scrolledPercent >= this.currentModalInfo.scroll_percent) {
          this.needShow = true

          this.saveViewedModal()

          this.cleanupScrollListener()
        }
      }

      this.scrollHandler = handleScroll

      this.$nextTick(() => {
        window.addEventListener('scroll', this.scrollHandler)

        handleScroll()
      })
    },

    cleanupScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler)

        this.scrollHandler = null
      }
    },

    saveViewedModal() {
      if (this.currentModalInfo && this.currentModalInfo.pk) {
        modalConfigViewResource.execute({}, { campaign: this.currentModalInfo.pk })
      }
    },

    close() {
      this.needShow = false
    },

    closeOverlayHandler() {
      if (this.currentModalInfo && this.currentModalInfo.close_overlay_enabled) {
        this.close()
      }
    },
  },
}
</script>
